import { InstallationInvitationsDto } from 'src/Libs/installation-rights-management/dto'
import { InstallationInvitationModel } from 'src/Libs/installation-rights-management/models'

const installationInvitationsToToModelTransformer = (values: InstallationInvitationsDto): InstallationInvitationModel[] => {
  return values.token.map((token, index) => ({
    token,
    installationId: values.installationId[index] || -1,
    accountId: values.accountId[index] || '',
    inviteType: values.inviteType[index] || 'invite',
    createdAt: values.createdAt[index] || '',
    updatedAt: values.updatedAt[index] || '',
    deletedAt: values.deletedAt[index] || null,
    expiredAt: values.expiredAt[index] || null,
  }))
}

export default installationInvitationsToToModelTransformer
